import React from 'react';
import axios from 'axios';
import AppVars from '../../AppVars.js'
import Logger from '../../Logger.js';
import { constants } from '../../constants/constants';
import ActivateFailureView from '../Views/TO/Activate/ActivateFailureView';
import {parseCookies, isValidGoToURL} from 'account-portal-library/lib/helperFunctions'

const appVars = AppVars.getInstance();
const logger = Logger.getInstance();


class ActivateFailure extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,
            email: "",
            successEmail: "",

            // This component manages what to render using these state values
            // title: "",
            // showLogin: null,
            // showContact: null,
            // contentSection: "",
            floatEmail: false,
            isFormValid: true,
            
            // State for resending activation email and the outcome of that functionality
            loadingResend: false,
            resendSuccess: false,
            resendFailure: false,
            resendEmailSent: false,
            userAlreadyActivated: false,
            resendEmailFail: false,
            userNotFound: false,
            onFocus: false

        }
        this.emailRegex = new RegExp(constants.EMAIL_VALIDATION_REGEX)
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.sendNewEmailActivation = this.sendNewEmailActivation.bind(this);
        this.setFocus = this.setFocus.bind(this);
        this.removeFocus = this.removeFocus.bind(this);
        // this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    render() {
        return(
            <ActivateFailureView
            successEmail = {this.props.successEmail}
            resendSuccess = {this.state.resendSuccess}
            resendFailure = {this.state.resendFailure}
            resendEmailSent = {this.state.resendEmailSent}
            resendEmailFail = {this.state.resendEmailFail}
            userNotFound = {this.state.userNotFound}
            userAlreadyActivated = {this.state.userAlreadyActivated}
            floatEmail = {this.state.floatEmail}
            loadingResend = {this.state.loadingResend}
            isFormValid = {this.state.isFormValid}
            setFocus = {this.setFocus}
            removeFocus = {this.removeFocus}
            onFocus = {this.state.onFocus}
            sendNewEmailActivation = {this.sendNewEmailActivation}
            handleEmailChange = {this.handleEmailChange}
            />
        )
    }

    async sendNewEmailActivation(event) {
        event.preventDefault()
        const email = this.state.email.trim();
        const valid = this.validateInput();
        this.setState({ isFormValid: valid });
        if (valid) {
            this.setState({ loadingResend: true })
            const parsedCookies = parseCookies(document.cookie);
            let redirectURI;
            if (Object.keys(parsedCookies).includes("login_uri") && isValidGoToURL('T', parsedCookies["login_uri"])){
                redirectURI = parsedCookies["login_uri"]
            }
            else if (Object.keys(parsedCookies).includes("login_uri") && isValidGoToURL('S', parsedCookies["login_uri"])){
                redirectURI = parsedCookies["login_uri"]
            }
            else {
                redirectURI = "/"
            }
            /*if (sessionStorage.AP_STYLE === "DG"){
                const xclient = 'SI-REG'
            } else {
                xclient = 'TO-WEB'
            }*/
            const body = {
                'redirectURI' : redirectURI
            }
            // Network Requests
            /*axios({
                method: 'post',
                data: body,
                url: appVars.getDCS3BaseURL() + '/v2/admin/account/activation/email/' + email,
                headers: {
                    'X-API-KEY': await appVars.getAPIKey(),
                    'X-BRAND': 'T',
                    'X-CLIENT': xclient,
                    'X-VERSION': '1.6',
                    'Content-Type': 'application/json'
                }
            }).then((resp) => this.handleDCS3Response(resp))
            .catch((err) => this.handleDCS3Error(err))
            */

            const headers = {
                "x-client" : "FR-Portal-Toyota",
                //'X-CLIENT': xclient,
                'X-BRAND': 'T',
            }
    
            axios({
                method: 'post',
                headers,
                //params,
                data: body,
                url: appVars.getAPIGatewayURL() + "/activation/" + email,
    
            }).then((resp) => this.handleDCS3Response(resp))
            .catch((err) => this.handleDCS3Error(err))
            
        } else {
            this.setState({
                loadingResend: false,
                resendSuccess: false,
                resendFailure: false,
                resendEmailSent: false,
                userAlreadyActivated: false,
                resendEmailFail: false,
                userNotFound: false
            });
        }

    }

    handleDCS3Response(resp) {
        // Following along with the DCS3 repo
        const res = resp['data']
        logger.log('stage', res);
        if (res['status']['messages'][1]) {
            if (res['status']['messages'][1]['code'] == constants.USER_ALREADY_ACTIVATED) {
                this.setState({
                    loadingResend: false,
                    isFormValid: true,
                    resendSuccess: true,
                    resendFailure: false,
                    resendEmailSent: false,
                    userAlreadyActivated: true,
                    resendEmailFail: false,
                    userNotFound: false
                });
            }
        } else if (res['status']['messages'][0]) {
            logger.log('stage', res['status']['messages'][0])
            if (res['status']['messages'][0]['code'] == 'M00000') {
               logger.log('stage', 'REQUEST_COMPLETED_SUCCESSFULLY');

                this.setState({
                    loadingResend: false,
                    isFormValid: true,
                    resendSuccess: true,
                    resendFailure: false,
                    resendEmailSent: true,
                    userAlreadyActivated: false,
                    resendEmailFail: false,
                    userNotFound: false,
                    successEmail: this.state.email.trim()
                });
            }
        } else {
            // We got something real werid, go back to defaults
            this.setState({
                loadingResend: false,
                isFormValid: true,
                resendSuccess: false,
                resendFailure: false,
                resendEmailSent: false,
                userAlreadyActivated: false,
                resendEmailFail: false,
                userNotFound: false
            })
        }
    }


    handleDCS3Error(err) {
        // Following along with the DCS3 repo
        if (err.response.status == 404) {
            
            this.setState({
                loadingResend: false,
                isFormValid: true,
                resendSuccess: false,
                resendFailure: true,
                resendEmailSent: true,
                userAlreadyActivated: false,
                resendEmailFail: false,
                userNotFound: true
            });
        } else {
            this.setState({
                loadingResend: false,
                isFormValid: true,
                resendSuccess: false,
                resendFailure: true,
                resendEmailSent: true,
                userAlreadyActivated: false,
                resendEmailFail: true,
                userNotFound: false
            });
        }
    }

    setFocus(event){
        this.setState({onFocus: true})
        this.setState({isFormValid: null})
    }

    removeFocus(){
        if(this.state.email === ""){
            this.setState({onFocus: false})
        }else{
            this.setState({onFocus: true})
        }
    }

    validateInput() {
        const email = this.state.email.trim()
        const invalidInput = !email || !this.emailRegex.test(email);
        return !invalidInput;
    }


    handleEmailChange(event) {
        this.setState({email: event.target.value})
        this.setState({isFormValid: null})
    }
}

export default ActivateFailure